export class ListaPaginada<T> extends Array<T> {
    pagina: Pagina
    quantidadeTotal: number

    get quantidade(): number {
        return this.length
    }

    constructor(items: T[], indicePagina: number, tamanhoPagina: number, quantidadeTotal: number) {
        super()

        this.push.apply(this, items)
        this.pagina = new Pagina(indicePagina, tamanhoPagina)
        this.quantidadeTotal = quantidadeTotal
    }
}

export class Pagina {
    indice: number
    tamanho: number

    constructor(indice: number = 1, tamanho: number = 10) {
        this.indice = indice
        this.tamanho = tamanho
    }

    toLimitOffset() {
        return {
            limit: this.tamanho,
            offset: (this.indice - 1) * this.tamanho
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/pkw-data/core/util/lista-paginada.model.ts